import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

// Resolve a server media path (e.g. "/api/files/..") to an absolute URL.
export function resolveMediaUrl(path) {
  if (!path) return "";
  if (/^https?:\/\//i.test(path)) return path;
  return `${process.env.REACT_APP_BACKEND_URL}${path.startsWith("/") ? "" : "/"}${path}`;
}

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("fh_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Sliding session: persist a refreshed token whenever the backend issues one.
api.interceptors.response.use((response) => {
  const refreshed = response.headers?.["x-refresh-token"];
  if (refreshed && localStorage.getItem("fh_token")) {
    localStorage.setItem("fh_token", refreshed);
  }
  return response;
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
